import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import PointerContainer from '~/landing/components/PointerContainer'
import { MathRecipeItemProps } from '~/landing/consts/Landing.consts'

export default function MathRecipeItemDesktop({
  props,
  isLastItem,
}: {
  props: MathRecipeItemProps
  isLastItem: boolean
}): React.ReactElement {
  const { step, icon, iconClassName, title, description } = props

  const { t } = useTranslation('landing')

  const pointUp = step % 2 === 1
  const nodeClassName = isLastItem ? 'bg-bronze text-white' : pointUp ? 'bg-purple text-white' : 'bg-white text-purple'
  return (
    <div
      className={`flex justify-center items-center h-full max-w-full z-20 ${pointUp ? 'flex-col-reverse' : 'flex-col'}`}
    >
      <div className={`flex ${pointUp ? 'items-start' : 'items-end'} h-70 `}>
        <PointerContainer
          className={`h-36 w-36 lg:h-44 lg:w-44 xl:h-48 xl:w-48 2xl:h-70 2xl:w-59 ${
            pointUp ? 'mt-8 lg:mt-10 2xl:mt-12' : 'mb-8 lg:mb-12 2xl:mb-14'
          }`}
          direction={pointUp ? 'up' : 'down'}
          isLastItem={isLastItem}
        >
          <div className={`flex flex-col gap-2 w-full justify-center items-center h-5/6 ${pointUp ? 'mt-10' : 'mb-8'}`}>
            <p className="text-5 font-bold leading-[1.2]">{t(title)}</p>
            <p className="text-md leading-[1.4]">{t(description)}</p>
          </div>
        </PointerContainer>
      </div>
      <div className={`flex items-center justify-start ${pointUp ? 'flex-col-reverse' : ' flex-col'} min-h-70 w-full`}>
        <div
          className={`rounded-full px-4 py-1 ${
            pointUp ? `${nodeClassName} -mb-2 2xl:-mb-3.5` : `${nodeClassName} -mt-3 2xl:-mt-6`
          }`}
        >
          <p className="text-xs 2xl:text-5 font-bold uppercase">{`${t('mathRecipe.step')} ${step}`}</p>
        </div>
        <div className="w-22 h-40 lg:w-26 md:h-26 xl:w-32 xl:h-32 2xl:w-40 2xl:h-40">
          <ResponsiveImage
            fetchPriority="high"
            fit="contain"
            height={160}
            imageClassName={`${iconClassName}`}
            loading="eager"
            srcKey={icon}
            width={160}
          />
        </div>
      </div>
    </div>
  )
}
